module.exports = __webpack_public_path__ + "img/view3d-notice-2-light.65b13780.png";